import { render, staticRenderFns } from "./TabsContent3.vue?vue&type=template&id=bab416d4&scoped=true"
import script from "./TabsContent3.vue?vue&type=script&lang=js"
export * from "./TabsContent3.vue?vue&type=script&lang=js"
import style0 from "./TabsContent3.vue?vue&type=style&index=0&id=bab416d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab416d4",
  null
  
)

export default component.exports